import interceptedAxios from '../../../utils/interceptedAxios'

interface IKPIData {
  kpi_definition_id: string
  timestamp: string
  kpi_name: string
  kpi_value: number
  execution_status: string | null
  is_custom_kpi: boolean
  units: string
  colorValue: string
  formattedValue: string | null
}

interface IRegisterReading {
  readingTime: string
  value: number
  indexValue: number
  registerName: string
  units: string
  formattedValue: string | null
  cimCodeId: string
  colorValue: string
}

export interface IDeviceStatusRegisterData {
  asset_id: string
  tenant_id: string
  registerReadings: IRegisterReading[]
}

export interface IDeviceStatusKPIData {
  asset_id: string
  tenant_id: string
  kpi_data: IKPIData[]
}

export function fetchDeviceStatusRegisterSummary (
  siteId: string,
  deviceIds: string,
  cimCodeIds: string,
  isDefault: boolean,
  onSuccess: (metadata: IDeviceStatusRegisterData | null, httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): void {
  const url = `/asset-data-service/api/v1/udp/tiq/assets/data/register/dashboard/deviceStatus/summary?graphName=deviceStatus&cimCodeIds=${cimCodeIds}&deviceId=${deviceIds}&siteId=${siteId}&isDefault=${isDefault.toString()}`
  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response) => {
      const responseData = response.data
      if (responseData.error === false) {
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(
          error.response.data !== undefined && error.response.data !== null
            ? error.response.data.error_message
            : 'Network Error',
          error.response.status
        )
      } else {
        onFailure('Network Error', 404)
      }
    })
}

export function fetchDeviceStatusKPISummary (
  siteId: string,
  deviceIds: string,
  kpiDefinitionIds: string,
  isDefault: boolean,
  onSuccess: (metadata: IDeviceStatusKPIData | null, httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): void {
  const url = `/kpirest/api/v1/udp/tiq/dashboard/deviceStatus/summary?graphName=deviceStatus&kpiDefinitionIds=${kpiDefinitionIds}&deviceId=${deviceIds}&siteId=${siteId}&isDefault=${isDefault.toString()}`
  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response) => {
      const responseData = response.data
      if (responseData.error === false) {
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(
          error.response.data !== undefined && error.response.data !== null
            ? error.response.data.error_message
            : 'Network Error',
          error.response.status
        )
      } else {
        onFailure('Network Error', 404)
      }
    })
}
